import { lazy, Suspense } from "react";
import { Layout } from "@/components/layout/Layout";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import heroVideo from "@/assets/hero-video.mp4";
import heroVideoDesktop from "@/assets/hero-video-desktop.mp4";

const IndexBelowFold = lazy(() => import("@/components/IndexBelowFold"));

const Index = () => {
  return (
    <Layout>
      {/* Hero Section */}
      <section className="relative min-h-screen flex items-center overflow-hidden">
        {/* Background Video */}
        <div className="absolute inset-0">
          {/* Mobile Video */}
          <video
            autoPlay
            loop
            muted
            playsInline
            preload="none"
            className="w-full h-full object-cover scale-[1.2] md:hidden"
          >
            <source src={heroVideo} type="video/mp4" />
          </video>
          {/* Desktop Video */}
          <video
            autoPlay
            loop
            muted
            playsInline
            preload="none"
            className="w-full h-full object-cover scale-[1.2] hidden md:block"
          >
            <source src={heroVideoDesktop} type="video/mp4" />
          </video>
          <div className="absolute inset-0 bg-gradient-to-r from-charcoal/90 via-charcoal/70 to-charcoal/40" />
        </div>

        {/* Content */}
        <div className="container-elegant relative z-10">
          <div className="max-w-2xl">
            <span className="inline-block text-gold-light text-sm tracking-[0.3em] uppercase mb-6">
              Instituto Biomédico Clínico e de Ensino
            </span>
            <h1 className="font-display text-4xl md:text-5xl lg:text-6xl text-cream font-medium leading-tight mb-6">
              Saúde, autoestima e{" "}
              <span className="italic">cuidado</span> com você
            </h1>
            <p className="text-cream/80 text-lg md:text-xl leading-relaxed mb-10">
              Referência em tratamentos multidisciplinares com equipe altamente 
              qualificada e tecnologia de ponta.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <Button asChild variant="hero" size="lg">
                <a
                  href="https://api.whatsapp.com/message/LVSHX74FFHBTI1?autoload=1&app_absent=0"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Agendar Consulta
                  <ArrowRight size={18} />
                </a>
              </Button>
              <Button asChild variant="outline" size="lg" className="border-cream/30 text-cream hover:bg-cream/10 hover:text-cream">
                <Link to="/tratamentos">
                  Conhecer Tratamentos
                </Link>
              </Button>
            </div>
          </div>
        </div>

        {/* Scroll Indicator */}
        <div className="absolute bottom-10 left-1/2 -translate-x-1/2 animate-fade-in" style={{ animationDelay: '1.5s', animationFillMode: 'both' }}>
          <div className="w-6 h-10 border-2 border-cream/30 rounded-full flex items-start justify-center p-2">
            <div className="w-1.5 h-1.5 bg-cream rounded-full animate-scroll-dot" />
          </div>
        </div>
      </section>

      <Suspense fallback={null}>
        <IndexBelowFold />
      </Suspense>
    </Layout>
  );
};

export default Index;
